import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

export const getBillInfo = async (startDate, endDate) => {
  const searchParam = new URLSearchParams({
    startDate,
    endDate,
  });
  const res = await fetchApi.get(
    API_URL.GET_BILL + "?" + searchParam.toString()
  );
  return res.data;
};
/**
 * 고객 고지서(A2 Phase G). month='YYYY-MM'.
 * 응답 `mode` 가 라우팅의 단일 소스다 — LEGACY 면 기존 /cash/bill·/cash/tax-invoice 로,
 * INVOICE 면 확정 정산서(`channels`)로 그린다. cutoff 값은 서버가 쥐고 있고 프론트에 상수로 두지 않는다.
 */
export const getCustomerInvoice = async (month) => {
  const res = await fetchApi.get(`${API_URL.GET_INVOICE}?month=${month}`);
  return res.data;
};

/**
 * 현재 채널이 고를 수 있는 이용월 목록(2026-10-15). `{ cutoffMonth, months: [{month, mode, status}] }`, 최근순.
 * 가입 전 달·오지 않은 달·구독이 끊긴 달은 서버가 애초에 내려주지 않는다 — 프론트가 달을 만들어 내지 않는다.
 */
export const getInvoiceMonths = async () => {
  const res = await fetchApi.get(API_URL.GET_INVOICE_MONTHS);
  return res.data;
};

export const getTaxInvoice = async (startDate) => {
  const res = await fetchApi.get(`${API_URL.GET_TAX_INVOICE}?startDate=${startDate}`);
  return res.data;
};

export const existsCard = async () => {
  const res = await fetchApi.get(API_URL.CARD_EXISTS)
  return res.data;
}

export const getCardInfoList = async () => {
  const res = await fetchApi.get(API_URL.CARD_INFO_LIST)
  return res.data;
}

export const getCardInfo = async (id) => {
  const res = await fetchApi.get(API_URL.CARD_INFO + `?cardId=${id}`)
  return res.data;
}

export const registrationCardBill = async (cardNumber, cardExpire, cardType, birth, pwd, isDefault) => {
  const res = await fetchApi.post(API_URL.PAYMENT_BILL,
      {
        cardNumber: cardNumber,
        cardExpire: cardExpire,
        cardType: cardType,
        birth: birth,
        pwd: pwd,
        isDefault: isDefault
      })
  return res.data;
}

export const pay = async (creditType, cardId, amount) => {
  const res = await fetchApi.post(`${API_URL.PAYMENT_PAY}`, {
    creditType: creditType,
    cardId: cardId,
    amount: amount,
  })
  return res.data;
}

export const refund = async (historyId, amount) => {
  const res = await fetchApi.post(`${API_URL.PAYMENT_REFUND}`, {
    historyId: historyId,
    amount: amount
  })
  return res.data;
}

/**
 * 카드 요청의 실패를 **사유가 담긴 Error 로 바꾼다**.
 *
 * `fetchApi.post` 는 HTTP 오류를 throw 하지 않고 axios 에러 객체를 **반환**하므로,
 * 이 변환이 없으면 호출부의 `try/catch` 가 걸리지 않아 실패해도 성공 alert 이 뜬다.
 * 백엔드는 사유를 `400 + CARD_ERROR(4091)` 의 `data` 에 문자열로 싣는다.
 */
const cardResult = (res, fallback) => {
  if (res?.isAxiosError || res?.response) {
    const body = res.response?.data;
    throw new Error(
      (typeof body?.data === "string" && body.data) ||
      res.message ||
      `${fallback} (HTTP ${res.response?.status ?? "응답 없음"})`
    );
  }
  if (!res) throw new Error("서버 응답을 받지 못했습니다. 잠시 후 다시 시도해 주세요.");
  return res.data;
};

export const changeDefaultCard = async (cardId) => {
  const res = await fetchApi.post(`${API_URL.CHANGE_CARD_DEFAULT}`, {
    cardId: cardId,
  })
  return cardResult(res, "기본 카드를 변경하지 못했습니다.");
}

/**
 * 카드 삭제. **실패하면 사유를 담아 throw 한다** — 호출부가 그 문구를 화면에 보여줘야 한다.
 *
 * 왜 필요한가(2026-08-06): `fetchApi.post` 는 HTTP 오류를 throw 하지 않고 axios 에러 객체를 **반환**한다.
 * 그래서 종전 `return res.data` 는 실패 시 조용히 `undefined` 를 돌려줬고, 호출부의 `try/catch` 는
 * 절대 걸리지 않아 **삭제가 실패해도 "카드가 삭제되었습니다" alert** 이 떴다.
 *
 * 백엔드는 실패를 `400 + CARD_ERROR(4091)` + 사유로 내려준다(마지막 1장 / 권한 없음 / 카드사 거부).
 * `REQUEST_DATA(4000)` 가 아니라서 `fetch.js` 의 전역 alert·미해결 Promise 경로를 타지 않는다.
 */
export const deleteCard = async (cardId) => {
  const res = await fetchApi.post(`${API_URL.CARD_DELETE}`, {
    cardId: cardId,
  })
  return cardResult(res, "카드를 삭제하지 못했습니다.");
}